import { useEffect, useRef } from "react";
import { useLocation } from "wouter";

function ScrollToTop() {
   const [location] = useLocation();
   const previousLocation = useRef<string>("");

   useEffect(() => {
      const previous = previousLocation.current;
      if (!previous?.startsWith("/produkter") || !location.startsWith("/produkter")) {
         window.scrollTo(0, 0);
      }
      previousLocation.current = location;
   }, [location]);

   return null;
}

export default ScrollToTop;
